/**
 *   RwdMove Widget - Move elements on reize
 *   Use jQuery
 */

;(function rwdMove($) {

    $(document).ready(init);

    var BREAKPOINT = 1100;
    var RESIZE_DELAY = 100;

    var CONTAINER_CLASS = '.js-RwdMove';
    var MOBILE_CLASS = '.js-RwdMove-mobile';
    var DESKTOP_CLASS = '.js-RwdMove-desktop';

    var $container;

    function init() {
        $container = $(CONTAINER_CLASS);

        if ($container.length === 1) {
            updateRespgrid();
            $(window).on('resize', debounce(updateRespgrid, RESIZE_DELAY));
        }
    }

    function updateRespgrid() {
        if ($(window).width() >= BREAKPOINT) {
            respGridToDesktop();
        } else {
            respGridToMobile();
        }
    }

    function respGridToDesktop() {
        $container.find(MOBILE_CLASS).each( function() {
            var $id = $(this).attr('data-id');
            var $content = $(this).html();
            var $target = $(DESKTOP_CLASS + '[data-id =' + $id + ']');

            if ($content !== '' && $target.length > 0) {
                $(this).empty();
                $target.html($content);
            }
        });
    }

    function respGridToMobile() {
        $container.find(DESKTOP_CLASS).each( function() {
            var $id = $(this).attr('data-id');
            var $content = $(this).html();
            var $origin = $(MOBILE_CLASS + '[data-id =' + $id + ']');

            if ($content !== '' && $origin.length > 0) {
                $(this).empty();
                $origin.html($content);
            }
        });
    }

})(jQuery);
